<template>
    <div class="course_home">
        <div class="course_home_page">
            <div class="navigation">
                <div class="tabs">
                    <div v-bind:class="{'tab_all_course':true, 'selected_tab':selectedTab === 1}" @click="selectedTabClick(1)">全部课程</div>
                    <div v-bind:class="{'tab_my_course':true, 'selected_tab':selectedTab === 2}" @click="selectedTabClick(2)">我的课程</div>
                </div>
                <div class="account">
                    <div v-if="getIsLogin() != 1" class="login" @click="loginClick">注册/登录</div>
                    <div v-else class="login_out" @click="confirmbox">退出登录</div>
                </div>
            </div>
            <div class="course_home_content">
                <div v-if="selectedTab === 1" class="all_course">
                    <div class="course_item" v-for="(course, index) in listData" :key="index" @click="entryBlog(course.guid, course.type)">
                        <div class="course_title">{{course.title}}</div>
                        <div class="course_age">{{course.ages}}</div>
                        <div class="course_poster"><img :src="course.poster" alt="" /></div>
                        <div class="course_detail_des">戳👆课程详细介绍</div>
                    </div>
                    <div style="padding-bottom:50px; height:30px;"></div>
                </div>
                <div v-else class="my_course">
                    <div v-if="!isEmpty(myCourseArray)">
                        <div class="my_course_item" v-bind:style="{'margin-top': index > 0 && index < myCourseArray.length - 1 ? '20px' : '0px'}"  v-for="(item, index) in myCourseArray" :key="index"
                             @click="getAfter(item.type, item.pk)">
                            <div class="img"><img v-lazy="getImage(item.listPoster)"/></div>
                            <div class="progress_tip">{{getfinishRate(item.finishRate)}}</div>
                            <div class="progress"><div class="progressing" v-bind:style="{width:item.finishRate + '%'}"></div></div>
                        </div>
                    </div>
                    <div v-else class="my_course_empty">
                        <div class="empty_tip">购买课程后，在我的课程里就可以上课了~</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {MessageBox} from "mint-ui";

    export default {
        name: "index",
        data() {
            return {
                selectedTab: 1,
                myCourseArray: [],
                listData: [
                    {title: "【原版数学启蒙绘本教材】《MathStart》系列", ages: "适合年龄：3-10岁", poster: require("@/Images/course_math_start.jpg"), guid: "1e7ec15c1303e32b", type: 7},
                    {title: "大猫分级阅读桥梁课-2 ：用权威教材、科学方式，带娃走上初章之路！", ages: "适合年龄：6-10岁", poster: require("@/Images/course_big_cat6.png"), guid: "1e7ec15c1303e32b", type: 6},
                    {title: "分级阅读桥梁课-1：用权威教材、科学方式，带娃走上初章之路！", ages: "适合年龄：5-9岁", poster: require("@/Images/course_big_cat5.png"), guid: "1e7ec15c1303e32b", type: 4},
                    {title: "“原版娃”英语启蒙第1步，掌握1000听力词汇", ages: "适合年龄：3-6岁", poster: require("@/Images/course_program.png"), guid: "", type: 5},
                    {title: "用思维导图，结构英语阅读理解。45天帮孩子养成结构化思维，终身受益", ages: "适合年龄：5-8岁", poster: require("@/Images/course_success.png"), guid: "65f98a95cb975bef", type: 1},
                    {title: "掌握英语词汇策略，大大提高孩子“记单词”效率", ages: "适合年龄：5-10岁", poster: require("@/Images/course_240word.png"), guid: "5aac20819410da48", type: 2},
                    {title: "跟着英国权威分级阅读教材走上原版阅读之路", ages: "适合年龄：4-8岁", poster: require("@/Images/course_big_cat.png"), guid: "5d8d219d5fd178c0", type: 3}
                ]
            }
        },
        methods: {
            getfinishRate:function(finishRate){
                let  intFinishRate = parseInt(finishRate);

                if (intFinishRate > 0) {
                    return "完成进度："+ intFinishRate +"%";
                }

                return "还未开始学习~";
            },
            selectedTabClick: function (tab) {
                let that = this;
                that.selectedTab = tab;

                if (parseInt(tab) === 2) {
                    that.refreshMyCourse();
                }
            },
            refreshMyCourse:function() {
                let that = this;

                that.$axios.get("my/getMyCourse/").then((response) => {
                    that.myCourseArray = response.data;
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            entryBlog: function (guid, type) {
                if (type === 4) {
                    this.$router.push({name: "BFAfter", query: {courseId: 1}});
                } else if (type === 6) {
                    this.$router.push({name: "BFAfter", query: {courseId: 2}});
                } else if (type === 5) {
                    this.$router.push({name: "PAfter", query: {courseId: 1}});
                } else if (type === 7) {
                    this.$router.push({name: "MAfter", query: {courseId: 1}});
                } else {
                    const newPage = this.$router.resolve({name: "CourseBlog", query: {id: guid, type: type}});
                    window.open(newPage.href,'_blank');
                }
            },
            getBefore(id) {
                this.$router.push({path: "/before", query: {courseId: id}})
            },
            getXueLeBefore(id) {
                if (id === 1 || id === 2) {
                    this.$router.push({name: "SBefore", query: {courseId: id}})
                } else {
                    MessageBox.confirm('', {
                        message: ' ',
                        title: '课程即将推出',
                        showConfirmButton:false,
                        showCancelButton:true,
                        closeOnClickModal: false,
                        cancelButtonClass:'cancelButton',
                        confirmButtonClass:'confirmButton',
                        cancelButtonText:'知道了'
                    });
                }
            },
            getAfter(type, id) {
                if (type === 2) {
                    this.$router.push({name: "After", query: {courseId: id}})
                } else if (type === 3) {
                    this.$router.push({name: "SAfter", query: {courseId: id}})
                } else if (type === 4) {
                    this.$router.push({name: "BFAfter", query: {courseId: 1}})
                } else if (type === 5) {
                    this.$router.push({name: "PAfter", query: {courseId: id}})
                } else if (type === 6) {
                    this.$router.push({name: "BFAfter", query: {courseId: 2}})
                } else if (type === 7) {
                    this.$router.push({name: "MAfter", query: {courseId: 1}})
                }
            },
            loginClick:function () {
                this.$router.push({path: "/login"})
            },
            loginoutClick:function () {
                let that = this;

                that.$axios.get("/my/logout").then((response) => {
                    let vRsult = response.data;

                    if (that.getCount(vRsult) === 1) {
                        that.$store.dispatch('UserLogout');

                        if (that.selectedTab === 2) {
                            that.refreshMyCourse();
                        }
                    }
                }).catch(function (error) {
                    window.console.log(error)
                });
            },
            getIsLogin:function () {
                let that = this;
                return that.isEmpty(that.$store.state.token) ? 0 : 1;
            },
            jumpArticleClick:function (id) {
                this.$router.push({name: 'pageView', query: {url: "https://xiaohuasheng.cn/mblog_"+ id +"/come_1/user_0"}});
            },
            getImage:function (img) {
                return  this.$qiNiuDomainBase + img;
            },
            confirmbox () {
                let that = this;
                MessageBox.confirm('', {
                    message: ' ',
                    title: '确定要退出吗？',
                    showConfirmButton:true,
                    showCancelButton:true,
                    closeOnClickModal: false,
                    cancelButtonClass:'cancelButton',
                    confirmButtonClass:'confirmButton',
                    confirmButtonText:'确定退出',
                    cancelButtonText:'取消'
                }).then(action => {
                    if (action == 'confirm') {
                        window.console.log("退出")
                        that.loginoutClick();
                    }
                }).catch(err => {
                    if (err == 'cancel') {
                        window.console.log("取消")
                    }
                });
            },
        },
        activated() {
            let that = this;
            let token = that.$store.state.token;
            let isLogin = !that.isEmpty(token);

            if (!isLogin) {
                this.selectedTab = 1;
            } else {
                if (window.isCreate != null && window.isCreate === 0 && this.selectedTab === 2) {
                    that.refreshMyCourse();
                }
            }

            window.isCreate = 0;
        },
        beforeCreate(){
            window.isCreate = 1;
        }
    }
</script>

<style scoped>
    .course_home {
        position:absolute;
        width:100%;
        height:auto;
        min-height: 100%;
        text-align: center;
    }
    .course_home_page {
        max-width: 590px;
        height:auto;
        min-height: 100%;
        word-wrap: break-word;
        word-break: normal;
        margin: 0px auto;
        text-align: left;
        background-color: white;
    }
    .navigation {
        width: 100%;
        height: 54px;
        position: fixed;
        top: 0px;
        background-color: white;
        max-width: 590px;
    }
    .navigation .tabs {
        color: #333333;
        font-size: 17px;
        font-weight: bold;
        text-align: left;
        margin-left: 20px;
        position: absolute;
        bottom: 10px;
    }
    .navigation .tabs .selected_tab {
        color: #ff5050;
        border-bottom: 3px solid #ff5050;
    }
    .navigation .tabs .tab_all_course {
        display: inline-block;
        padding-bottom: 3px;
    }
    .navigation .tabs .tab_my_course {
        display: inline-block;
        margin-left: 30px;
        padding-bottom: 3px;
    }
    .account {
        position: absolute;
        right:20px;
        bottom: 15px;
    }
    .account .login {
        background-color: #ff5050;
        color: white;
        width: 94px;
        height: 30px;
        font-size: 15px;
        font-weight: bold;
        line-height: 30px;
        border-radius: 15px;
        -webkit-border-radius: 15px;
        -moz-border-radius: 15px;
        text-align: center;
    }
    .account .login_out {
        font-size: 15px;
        font-weight: bold;
        color: #ff5050;
    }
    .course_home_content {
        max-width: 100%;
    }
    .all_course
    {
        padding-top:44px;
    }
    .my_course {
        padding-top: 74px;
        padding-bottom: 20px;
    }
    .my_course_item .img img {
        width: 100%;
    }
    .my_course_item {
        margin: 0px 20px 20px 20px;
        border: 1px solid #E5E3E3;
        border-radius: 10px;
        -webkit-border-radius: 10px;
        -moz-border-radius: 10px;
    }
    .my_course_item .img img {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        -webkit-border-top-left-radius: 10px;
        -webkit-border-top-right-radius: 10px;
        -moz-border-radius-topleft: 10px;
        -moz-border-radius-topright: 10px;
    }
    .my_course_item .progress_tip {
        font-size: 13px;
        color: #999999;
        margin: 40px 20px 0px 20px;
    }
    .my_course_item .progress {
        width:  calc(100% - 40px);
        height: 10px;
        background-color: #f4f4f4;
        margin: 5px 20px 20px 20px;
    }
    .my_course_item .progressing {
        background-color: #24c889;
        height: 100%;
    }
    .my_course_empty {
        position:absolute;
        width:100%;
        max-width: 590px;
        height:auto;
        min-height: calc(100% - 74px);
        text-align: center;
        background-color: white;
        font-size: 16px;
        color: #999999;
    }
    .empty_tip {
        position:absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translateX(-50%) translateY(-50%);
    }

    .course_item
    {
        margin-left: 15px;
        margin-right: 15px;
        margin-top: 20px;
        margin-bottom: 50px;
    }
    .course_item .course_title
    {
        color: #1a1a1a;
        font-size: 20px;
        font-weight: bold;
        text-align: left;
    }
    .course_item .course_age
    {
        color: #999999;
        font-size: 13px;
        margin-top: 10px;
        margin-bottom: 15px;
        text-align: left;
    }
    .course_item .course_poster img
    {
        width: 100%;
        border-radius: 5px;
        -webkit-border-radius: 5px;
        -moz-border-radius: 5px;
    }
    .course_item .course_detail_des
    {
        color: #999999;
        font-size: 13px;
        margin-top: 10px;
        margin-bottom: 15px;
        text-align: center;
    }

</style>
